import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import Styles from "./generate.module.css";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { Services } from "Services";
import { Error, Success_Dark, Error_Dark, warningSwal } from "Util/Toast";
import { AiOutlineClose } from "react-icons/ai";
import ReactLoading from "react-loading";
import Select from "react-select";

Modal.setAppElement("#root");

const Filter = ({
    setShowPaymentModal,
    showPaymentModal,
    Transactions,
    TutorId,
}) => {
    const [searchparams] = useSearchParams();
    const [batches, setBatches] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [SelectedClass, setSelectedClass] = useState([]);
    const [BatchSearchBatch, setTutorSearchBatch] = useState(null);
    const [BatchSearchLoad, setBatchSearchLoad] = useState(false);
    const [classes, setClasses] = useState([]);
    const [batchLoad, setBatchLoad] = useState(false);
    let creditReason = [
        "Adjustment for wrong class duration",
        "Waiting charge to be given to the teacher while the parent is not charged",
        " Penalty reversal",
        "Others ",
    ];
    let debitReason = [
        "Teacher marked the class by mistake",
        "Admin marked the class by mistake",
        "Admin marked the class as No Show",
        "Adjustment for wrong class duration",
        "Teacher conducted wrong file number",
        "Others",
    ];

    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (
                typeof BatchSearchBatch == "string" &&
                BatchSearchBatch.length > 0
            ) {
                setBatchSearchLoad(true);

                try {
                    const data = await Services.Search_Tutor_Batch(
                        "POST",
                        JSON.stringify({
                            BatchName: BatchSearchBatch,
                            TutorID: TutorId,
                        }),
                        token
                    );
                    const formattedOptions = data.Batches.map((student) => ({
                        label: `${student.BatchName}`,
                        value: student.BatchID,
                    }));
                    setBatches(formattedOptions);
                } catch (error) {
                    console.error("Error fetching options:", error);
                } finally {
                    setBatchSearchLoad(false);
                }
            }
        }, 300);

        return () => clearTimeout(debouncedSearch);
    }, [BatchSearchBatch]);
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({ defaultValues: { Credit_Or_Debit: "CREDIT" } });
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const [load, setLoad] = useState(false);
    const [options, setoptions] = useState(creditReason);

    const closeModal = () => {
        setShowPaymentModal(false);
        reset();
    };

    const onSubmit = (formdata) => {
        let body = {
            ...formdata,
            Amount: Number(formdata.Amount),
            TutorID: TutorId,
        };
        if (selectedBatch) {
            body = { ...body, BatchID: selectedBatch.value };
        }

        if (selectedBatch && SelectedClass.length > 0) {
            body = {
                ...body,
                ScheduleClassID: SelectedClass.map((item) => item.value),
            };
        }
        setLoad(true);
        Services.manual_adjust_tutorearnings(
            "POST",
            JSON.stringify(body),
            token
        )
            .then((response) => {
                if (response.Status === 1) {
                    Transactions();
                    setLoad(false);
                    Success_Dark(response.Message);
                    closeModal();
                } else if (response.Status === 0) {
                    Error(response.Message);
                    setLoad(false);
                }
            })
            .catch((err) => {
                setLoad(false);
                console.log(err);
                Error("something went wrong please try again");
            });
    };
    const blurHandler = (e) => {
        e.preventDefault();
        e.target.blur();

        return false;
    };
    const onBatchSelect = (option) => {
        if (option) {
            getClassDetails(option.value);
        } else {
            setClasses([]);
        }
        setSelectedClass([]);
        setSelectedBatch(option);
    };
    const handleChange = (selectedOption) => {
        setTutorSearchBatch(selectedOption);
    };
    const TutorClearHandler = () => {
        setTutorSearchBatch(null);
        setSelectedBatch(null);
    };
    const classClearHandler = () => {
        setSelectedClass([]);
    };
    async function getClassDetails(batchId) {
        setBatchLoad(true);
        try {
            const batchDetails = await Services.classDetailsByBatchId(
                "GET",
                null,
                token,
                batchId
            );
            if (batchDetails.Status == 1) {
                setBatchLoad(false);
                if (
                    batchDetails?.ScheduleClasess &&
                    batchDetails.ScheduleClasess.length > 0
                ) {
                    setClasses(
                        batchDetails.ScheduleClasess?.map((item) => ({
                            label: item.ClassLessonName,
                            value: item.ScheduleClassID,
                        }))
                    );
                }
            }
        } catch (err) {
            setBatchLoad(false);
            console.log(err);
        }
    }
    console.log(classes);
    const onClassSelect = (option) => {
        setSelectedClass(option);
        // setValue("ScheduleClassID", option.value);
    };
    return (
        <Modal
            isOpen={showPaymentModal}
            contentLabel="Modal"
            className={Styles["modal"]}
            onRequestClose={closeModal}
            overlayClassName={Styles["overlay"]}>
            <div
                className={Styles["form-wrapper"]}
                style={{
                    overflowY: "auto",
                    maxHeight: "80vh",
                    width: "100%",
                    overflowX: "hidden",
                }}>
                {/*   <button onClick={closeModal}>
                    <AiOutlineClose />
                </button> */}
                <h2>Balance Adjustment</h2>
                <form
                    onSubmit={handleSubmit(onSubmit)}
                    style={{ width: "98%" }}>
                    <div className={Styles["form-control"]}>
                        <div className={Styles["date-input-container"]}>
                            <select
                                {...register("Credit_Or_Debit", {
                                    required: true,
                                    onChange: (e) => {
                                        if (e.target.value == "Credit") {
                                            setoptions(creditReason);
                                        } else {
                                            setoptions(debitReason);
                                        }
                                        setValue("Adjustment_Reason", "");
                                    },
                                })}>
                                <option value="CREDIT">Credit</option>
                                <option value="DEBIT">Debit</option>
                            </select>
                        </div>
                        {errors.Credit_Or_Debit && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>

                    <div className={Styles["form-control"]}>
                        <div className={Styles["date-input-container"]}>
                            <input
                                placeholder="Amount"
                                type="number"
                                onWheel={blurHandler}
                                onScroll={blurHandler}
                                step={0.01}
                                {...register("Amount", {
                                    required: "This field is required",
                                    validate: (value) => {
                                        if (value < 0) {
                                            return "Amount cannot be a negative number";
                                        }
                                        return true; // Validation passed
                                    },
                                })}
                            />
                        </div>
                        {errors.Amount && (
                            <span className={Styles["error"]}>
                                {errors.Amount.message}
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control-select"]}>
                        <Select
                            options={batches}
                            onInputChange={handleChange}
                            onChange={onBatchSelect}
                            value={selectedBatch}
                            isLoading={BatchSearchLoad}
                            placeholder="Search Batch"
                            noOptionsMessage={() => "No Batch Found"}
                            classNames={Styles["select"]}
                            styles={{
                                // Set the width to 100%
                                control: (provided) => ({
                                    ...provided,
                                    width: "100%",
                                }),
                            }}
                            isClearable
                            /*  components={{
                                ClearIndicator: () => (
                                    <button onClick={TutorClearHandler}>
                                        Clear
                                    </button>
                                ),
                            }} */
                        />
                    </div>
                    <div className={Styles["form-control-select"]}>
                        <Select
                            options={classes}
                            onChange={onClassSelect}
                            value={SelectedClass}
                            isLoading={batchLoad}
                            placeholder="Search Class"
                            closeMenuOnSelect={false}
                            noOptionsMessage={() => "No Classes Found"}
                            classNames={Styles["select"]}
                            styles={{
                                // Set the width to 100%
                                control: (provided) => ({
                                    ...provided,
                                    width: "100%",
                                }),
                            }}
                            isMulti
                            isClearable
                            /*  components={{
                                ClearIndicator: () => (
                                    <button onClick={classClearHandler}>
                                        Clear
                                    </button>
                                ),
                            }} */
                        />
                    </div>
                    <div className={Styles["form-control"]}>
                        <div className={Styles["date-input-container"]}>
                            <select
                                {...register("Adjustment_Reason", {
                                    required: true,
                                })}
                                defaultValue={""}>
                                <option value="" disabled>
                                    Select Reason
                                </option>
                                {options.map((item) => (
                                    <option value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        {errors.Adjustment_Reason && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>
                    <div className={Styles["form-control"]}>
                        <div className={Styles["date-input-container"]}>
                            <textarea
                                rows={5}
                                placeholder="Comments"
                                {...register("AdjustmentComment", {
                                    required: true,
                                })}
                                type="text"
                            />
                        </div>
                        {errors.AdjustmentComment && (
                            <span className={Styles["error"]}>
                                This field is required
                            </span>
                        )}
                    </div>

                    {load ? (
                        <div
                            style={{
                                justifySelf: "center",
                                marginTop: "1rem",
                            }}>
                            {" "}
                            <ReactLoading
                                color="green"
                                type="spokes"
                                height={30}
                                width={30}
                            />
                        </div>
                    ) : (
                        <div className={Styles["buttons"]}>
                            <button type="submit" className={Styles["submit"]}>
                                Submit
                            </button>
                        </div>
                    )}
                </form>
            </div>
        </Modal>
    );
};
export default Filter;
